/* global $:false */

// Component capable of handling only numeric fields

import AutoNumeric from 'autonumeric';
import utils from '@cob/ui-genesis/cob.utils.js';

// Returns a number formatted with the default settings
// `forceDecimalPlaces` if true will disable the autoDetectInteger mode on the number
//                      (decimal places removal when the number is an integer)
var format = function(value, forceDecimalPlaces, nrDecimalPlaces, locale) {
    return utils.numbers.formatWithLocale(
        value,
        locale,
        nrDecimalPlaces == undefined ? 2 : nrDecimalPlaces,
        !forceDecimalPlaces)
};


// args:
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value
//
var NumberF = function(core, confs) {

    var _$input,
        autoNumericElement,
        _lastValue;

   const numberFormat = core.getNumberFormat();

    var _confs = {
        id: core.locallyUniqueId(),
        fieldDefinition: {name: ""},
        cssClasses : undefined,
        readonly: false,
        valueChanged: undefined,

        // configured as en-US, the same used in utils.numbers.format
        digitGroupSeparator: numberFormat.digitGroupSeparator,
        decimalCharacter: numberFormat.decimalCharacter,

        decimalPlaces: confs.decimalPlaces ?? 2,
        allowDecimalPadding: false,
        minimumValue: '-99999999999999',
        maximumValue: '99999999999999',
        leadingZero: "allow",
        modifyValueOnWheel:false
    };
    // to copy excel's behaviour and translate a . to a ,
    if(numberFormat.decimalCharacter === ','){
       _confs.decimalCharacterAlternative =  ".";
    }

    utils.extend(_confs, confs, true);

    var _setValue = function(value) {
        const val = Array.isArray(value) ? value[0] : value

        // We just want to notify
        // when the value changes.
        if (_lastValue !== val) {
            _lastValue = val;
        }

        if (_confs.valueChanged) {
            _confs.valueChanged(val);
        }
    };

    var _onValueChange = function() {
        _setValue(autoNumericElement.get());
    };

    var _render = function() {
        var $html = $([
            '<div class="inline">',
            '<input id="f' + _confs.id + '" class="field-value cob-field-value" type="text" placeholder="' + _confs.fieldDefinition.name + '">',
            '</div>'
        ].join(''));

        _$input = $html.find("input");
        autoNumericElement = new AutoNumeric(_$input[0], _confs);

        if (_confs.cssClasses) {
            _$input.addClass(_confs.cssClasses);
        }

        if (_confs.readonly) {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);

        } else {
            _$input.on('keyup paste blur change', _onValueChange);
        }

        if (_lastValue) {
            autoNumericElement.set(_lastValue);
            _$input.attr('raw-value', _lastValue);
        }

        return $html;
    };

    var _clearError = function() {
        _$input.removeClass("error");
    };

    var _showError = function() {
        _$input.addClass("error");
    };

    var _destroy = function() {
        autoNumericElement.remove();

        if (!_confs.readonly) {
            _$input.off('keyup paste blur change', _onValueChange);
        }
    };

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value) {
            if (_$input && value !== null && value !== undefined) {
                autoNumericElement.set(value)
                _$input.attr('raw-value', value);
            }

            // Notify that this field has a new value
            // to update fields that depend on this one ($autos, fields with placeholders, ...)
            _setValue(value);
        },
        getValue: function() {
            return _lastValue !== "" ? _lastValue : undefined;
        },
        disableSelf: function(){
            _$input.prop("readonly", true).attr("tabindex", -1);
        },
        enableSelf: function(){
            _$input.removeProp("readonly").removeAttr("tabindex");
        }
    }
};

export {format, NumberF};
